import { Component, EventEmitter, Input, Output } from '@angular/core';
import { multiselectOption, Options } from '../../models/chat';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-multiselect-button',
  standalone: true,
  imports: [
    MatCheckboxModule,
    CommonModule
  ],
  templateUrl: './multiselect-button.component.html',
  styleUrl: './multiselect-button.component.scss'
})
export class MultiselectButtonComponent {

  @Input() chip!:Options;
  // index of message
  @Input() i = 0;
  @Input() selected = false;

  @Output() checkOptionEvent = new EventEmitter<multiselectOption>()

  checkOption(name:string, flag:boolean, index:number){
    this.checkOptionEvent.emit({
      name, flag, index
    });
  }

}
